export const isValidNumber = (item: any): boolean => {
	if (typeof item === "number") {
		if (item > 0) {
			return true;
		}
	}
	return false;
};

export const numberToFixed = (item: number, len: number = 3): string => {
	if (!item) {
		return "0";
	}
	return item.toFixed(len);
};
